"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vortex = exports.Watch = exports.RotatingTriangles = exports.Triangle = exports.ThreeCircles = exports.ThreeDots = exports.TailSpin = exports.Rings = exports.RotatingLines = exports.RotatingSquare = exports.RevolvingDot = exports.Radio = exports.Puff = exports.ProgressBar = exports.Oval = exports.MutatingDots = exports.MagnifyingGlass = exports.LineWave = exports.InfinitySpin = exports.Hearts = exports.FidgetSpinner = exports.FallingLines = exports.Grid = exports.Dna = exports.Discuss = exports.Comment = exports.ColorRing = exports.CirclesWithBar = exports.Circles = exports.Blocks = exports.Bars = exports.BallTriangle = exports.Audio = void 0;
var Audio_1 = __importDefault(require("./loader/Audio"));
exports.Audio = Audio_1.default;
var BallTriangle_1 = __importDefault(require("./loader/BallTriangle"));
exports.BallTriangle = BallTriangle_1.default;
var Bars_1 = __importDefault(require("./loader/Bars"));
exports.Bars = Bars_1.default;
var Circles_1 = __importDefault(require("./loader/Circles"));
exports.Circles = Circles_1.default;
var CirclesWithBar_1 = __importDefault(require("./loader/CirclesWithBar"));
exports.CirclesWithBar = CirclesWithBar_1.default;
var Grid_1 = __importDefault(require("./loader/Grid"));
exports.Grid = Grid_1.default;
var Hearts_1 = __importDefault(require("./loader/Hearts"));
exports.Hearts = Hearts_1.default;
var InfinitySpin_1 = __importDefault(require("./loader/InfinitySpin"));
exports.InfinitySpin = InfinitySpin_1.default;
var LineWave_1 = __importDefault(require("./loader/LineWave"));
exports.LineWave = LineWave_1.default;
var MutatingDots_1 = __importDefault(require("./loader/MutatingDots"));
exports.MutatingDots = MutatingDots_1.default;
var Oval_1 = __importDefault(require("./loader/Oval"));
exports.Oval = Oval_1.default;
var Puff_1 = __importDefault(require("./loader/Puff"));
exports.Puff = Puff_1.default;
var RevolvingDot_1 = __importDefault(require("./loader/RevolvingDot"));
exports.RevolvingDot = RevolvingDot_1.default;
var Rings_1 = __importDefault(require("./loader/Rings"));
exports.Rings = Rings_1.default;
var RotatingSquare_1 = __importDefault(require("./loader/RotatingSquare"));
exports.RotatingSquare = RotatingSquare_1.default;
var RotatingLines_1 = __importDefault(require("./loader/RotatingLines"));
exports.RotatingLines = RotatingLines_1.default;
var TailSpin_1 = __importDefault(require("./loader/TailSpin"));
exports.TailSpin = TailSpin_1.default;
var ThreeCircles_1 = __importDefault(require("./loader/ThreeCircles"));
exports.ThreeCircles = ThreeCircles_1.default;
var ThreeDots_1 = __importDefault(require("./loader/ThreeDots"));
exports.ThreeDots = ThreeDots_1.default;
var Triangle_1 = __importDefault(require("./loader/Triangle"));
exports.Triangle = Triangle_1.default;
var Watch_1 = __importDefault(require("./loader/Watch"));
exports.Watch = Watch_1.default;
var FallingLines_1 = __importDefault(require("./loader/FallingLines"));
exports.FallingLines = FallingLines_1.default;
var Vortex_1 = __importDefault(require("./loader/Vortex"));
exports.Vortex = Vortex_1.default;
var RotatingTriangles_1 = __importDefault(require("./loader/RotatingTriangles"));
exports.RotatingTriangles = RotatingTriangles_1.default;
var Radio_1 = __importDefault(require("./loader/Radio"));
exports.Radio = Radio_1.default;
var ProgressBar_1 = __importDefault(require("./loader/ProgressBar"));
exports.ProgressBar = ProgressBar_1.default;
var MagnifyingGlass_1 = __importDefault(require("./loader/MagnifyingGlass"));
exports.MagnifyingGlass = MagnifyingGlass_1.default;
var FidgetSpinner_1 = __importDefault(require("./loader/FidgetSpinner"));
exports.FidgetSpinner = FidgetSpinner_1.default;
var Dna_1 = __importDefault(require("./loader/Dna"));
exports.Dna = Dna_1.default;
var Discuss_1 = __importDefault(require("./loader/Discuss"));
exports.Discuss = Discuss_1.default;
var ColorRing_1 = __importDefault(require("./loader/ColorRing"));
exports.ColorRing = ColorRing_1.default;
var Comment_1 = __importDefault(require("./loader/Comment"));
exports.Comment = Comment_1.default;
var Blocks_1 = __importDefault(require("./loader/Blocks"));
exports.Blocks = Blocks_1.default;
